import React, { useEffect, useRef, useState } from 'react'
import Area from '../../components/Locations/Area';
import City from '../../components/Locations/City';
import Country from '../../components/Locations/Country';
import State from '../../components/Locations/State';
import { no_image, search_icon } from '../../assets/imgs';
import CancelIcon from '@mui/icons-material/Cancel';
import Select from 'react-select';
import { useAreaAddMutation, useCityAddMutation, useCountryAddMutation, useDropDownLocationListMutation, useLazyCountryListQuery, useLazyLocationListQuery, useLazyStateListQuery, useLocationListMutation, useStateAddMutation, useStateListMutation } from '../redux/api/api';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';

const Locations = () => {
  const [tabs, setTabs] = useState(1);
  const [popup, setPopup] = useState(false);
  const [image, setImage] = useState(no_image);
  const fileInputRef = useRef(null);

  const [value, setValue] = useState();
  const [inputFeild, setInputFeild] = useState('')
  const [loader, setLoader] = useState(false);
  const [country, setCountry] = useState();
  const [state, setState] = useState();
  const [city, setCity] = useState();
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [pageno, setPageno] = useState(1);
  const [pagecount, setPagecount] = useState("");
  const [list, setList] = useState([]);
  const [type, setType] = useState();
  const [area, setArea] = useState();
  const [cityImage, setCityImage] = useState();
  const [stateValue, setStateValue] = useState();
  const [count, setCount] = useState({});
  const [cityValue, setCityValue] = useState();
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setcityList] = useState([]);
  const [page, setPage] = useState(1)
  console.log("statelist", stateList)

  const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

  const [dropDownLocationList] = useDropDownLocationListMutation();
  const [locationListApi] = useLocationListMutation();
  const [countryListApi] = useLazyCountryListQuery();
  const [stateListApi] = useLazyStateListQuery();
  const [countryAddApi] = useCountryAddMutation();
  const [stateAddApi] = useStateAddMutation();
  const [cityAddApi] = useCityAddMutation();
  const [areaAddApi] = useAreaAddMutation();



  const locationLists = (type, id, search) => {
    const formdata = new FormData();
    formdata.append("type", type)
    if (type != 1) {
      formdata.append("parent_id", id)
    }
    if (search) {
      formdata.append('search', search)
    }
    setLoader(true)
    dropDownLocationList(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        let arr = res?.data?.map((item, ind) => {
          let obj = {}
          obj.value = item.id
          obj.label = item.name
          return obj;
        })
        if (type == 1) {
          setCountryList(arr)
          setLoader(false)
        } else if (type == 2) {
          setStateList(arr)
          setLoader(false)
        } else if (type == 3) {
          setcityList(arr)
          setLoader(false)
        }
        // setList(res?.data?.data);

      })
      .catch((err) => {
        console.log("err", err);
      }).finally(() => {
        setLoader(false);
      })
  }


  const locationsApi = (page, search) => {
    const formdata = new FormData();
    formdata.append("type", tabs)
    formdata.append("page", page)
    formdata.append("row", 10)
    if (search) {
      formdata.append('search', search)
    }
    locationListApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        let temp = []
        res?.data?.map((item, ind) => {
          let obj = { ...item }
          obj.current_page = res?.pagination?.current_page
          temp.push(obj)
        })
        setList(temp);
        // setList(res?.data);
        setCount(res);
        setPagecount(res?.pagination)

      })
      .catch((err) => {
        console.log("err", err);
      })
  }

  useEffect(() => {
    locationsApi(pageno);
    // locationLists(1)
  }, [pageno, tabs]);


  const countryAdd = () => {
    const formdata = new FormData();
    if (tabs == 1 && !inputFeild) {
      toast.error("Enter Country");
      return
    }
    formdata.append("type", tabs);
    formdata.append("name", inputFeild);
    if (tabs == 2) {
      if (!country) {
        toast.error("Select Country");
        return
      }
      if (!inputFeild) {
        toast.error("Enter State");
        return
      }
      formdata.append("country_id", country.value);
    }
    if (tabs == 3) {
      if (!country) {
        toast.error("Select Country");
        return
      }
      if (!state) {
        toast.error("Select State");
        return
      }
      if (!inputFeild) {
        toast.error("Enter City");
        return
      }
      if (!latitude) {
        toast.error("Enter Latitude");
        return
      }
      if (!longitude) {
        toast.error("Enter Longitude");
        return
      }
      if (!image) {
        toast.error("Upload Image");
        return
      }
      formdata.append("country_id", country.value);
      formdata.append("state_id", state.value);

      if (image?.name) {
        formdata.append("image", image);
      }
      formdata.append("latitude", latitude);
      formdata.append("longitude", longitude);
    }
    if (tabs == 4) {
      if (!country) {
        toast.error("Select Country");
        return
      }
      if (!state) {
        toast.error("Select State");
        return
      }
      if (!city) {
        toast.error("Enter City");
        return
      }
      if (!inputFeild) {
        toast.error("Enter Area");
        return
      }
      formdata.append("country_id", country.value);
      formdata.append("state_id", state.value);
      formdata.append("city_id", city.value);
    }
    setLoader(true);
    let api = {
      1: countryAddApi,
      2: stateAddApi,
      3: cityAddApi,
      4: areaAddApi
    }[tabs];
    api(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          toast.success(res?.message);
          locationsApi();
          setLoader(false);
          setPopup(false);
          setImage(no_image);
          setLatitude();
          setLongitude();
          setCountry();
          setState();
          setCity();
          setInputFeild();
        }
      })
      .catch((err) => {
        console.log("err", err);
      }).finally(() => {
        setLoader(false);
      })
  }



  console.log('image', image);


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImage(file)
    // if (file) {
    //   const reader = new FileReader();
    //   reader.onload = () => {
    //     setImage(reader.result); // Set the selected image for cropping
    //   };
    //   reader.readAsDataURL(file);
    // }
  };

  return (
    <div className="dashRightView home_section" >
      <div className='d-flex ac-jb'>
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
          Locations
        </h2>
        <div className='d-flex gap-3'>
          < div className='search-input'>
            <input onChange={(e) => locationsApi(1, e.target.value)} type='text' placeholder='Search' style={{ border: 'none', width: '150px' }} />
            <img src={search_icon} className='search' />
          </div>
          {rolePermissions?.includes('CAN-ADD-MASTER') &&
            <button onClick={() => { setPopup(true); locationLists(1) }} className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn '> + Add </button>}
        </div>
      </div>
      <div className='d-flex gap-4 mt-3'>
        <h2 onClick={() => { setPageno(1); setTabs(1); setInputFeild('') }} className={`${tabs == 1 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Country ({count?.country_count})
        </h2>
        <h2 onClick={() => { setPageno(1); setTabs(2); setInputFeild('') }} className={`${tabs == 2 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          State  ({count?.state_count})
        </h2>
        <h2 onClick={() => { setPageno(1); setTabs(3); setInputFeild('') }} className={`${tabs == 3 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          City ({count?.city_count})
        </h2>
        <h2 onClick={() => { setPageno(1); setTabs(4); setInputFeild('') }} className={`${tabs == 4 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Area({count?.area_count})
        </h2>
      </div>

      {
        tabs == 1 && (
          <Country list={list} setPageno={setPageno} setPagecount={setPagecount} pagecount={pagecount}

          />
        )
      }
      {
        tabs == 2 && (
          <State list={list} setPageno={setPageno} setPagecount={setPagecount} pagecount={pagecount} />
        )
      }
      {
        tabs == 3 && (
          <City list={list} setPageno={setPageno} setPagecount={setPagecount} pagecount={pagecount}
            countryList={countryList} locationsApi={locationsApi}
          />
        )
      }
      {
        tabs == 4 && (
          <Area list={list} setPageno={setPageno} setPagecount={setPagecount} pagecount={pagecount} countryList={countryList} locationsApi={locationsApi} />
        )
      }
      {popup && (
        <div className="img-popup-design-new">
          <div className="img-popup-new">
            <div className='d-flex ac-jb' >
              <h4 className="f3 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 mt-2 sec">
                Add {tabs == 1 ? "Country" : tabs == 2 ? "State" : tabs == 3 ? "City" : tabs == 4 ? "Area" : ""}
              </h4>
              <button className='cust-btn' onClick={() => { setPopup(false); setCountry(''); setState(''); setCity(''); setImage(''); setLatitude(''); setLongitude(''); setInputFeild('') }}>
                <CancelIcon />
              </button>
            </div>
            {tabs == 1 && (
              <div>
                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  Country
                </h4>
                <input type="text" value={inputFeild} onChange={(e) => { setInputFeild(e.target.value) }} className="input-pop ps-2 w-100" placeholder="Country" />
              </div>

            )}
            {tabs == 2 && (
              <div>
                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  Country
                </h4>
                <Select
                  className='input-pop_box'
                  options={countryList}
                  value={country}
                  onChange={(e) => { setCountry(e) }}
                />
                {/* <input type="text" className="input-pop ps-2 w-100" placeholder="City" /> */}
                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  State
                </h4>
                <input type="text" value={inputFeild} onChange={(e) => setInputFeild(e.target.value)} className="input-pop ps-2 w-100" placeholder="State" />
              </div>

            )}
            {tabs == 3 && (
              <div>
                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  Country
                </h4>
                <Select
                  className='input-pop_box'
                  options={countryList}
                  value={country}
                  onChange={(e) => { setCountry(e); locationLists(2, e.value) }}
                />
                {/* <input type="text" className="input-pop ps-2 w-100" placeholder="Country" /> */}
                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  State
                </h4>
                <Select
                  className='input-pop_box'
                  options={stateList}
                  value={state}
                  onChange={(e) => { setState(e) }}
                />
                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  City
                </h4>
                <input type="text" value={inputFeild} onChange={(e) => setInputFeild(e.target.value)} className="input-pop ps-2 w-100" placeholder="City" />
                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  Latitude
                </h4>
                <input type="number" value={latitude} onChange={(e) => setLatitude(e.target.value)} className="input-pop ps-2 w-100" placeholder="Latitude" />
                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  Longitude
                </h4>
                <input type="number" value={longitude} onChange={(e) => setLongitude(e.target.value)} className="input-pop ps-2 w-100" placeholder="Longitude" />
                <div className=' mt-3'>
                  <div className='d-flex ac-js gap-4'>
                    <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  primary1">
                      Image Upload
                    </h4>
                    <button
                      className="upload-btn f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 "
                      onClick={() => { fileInputRef.current.click() }}
                    >
                      Upload
                    </button>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                    ref={fileInputRef} // Use the ref here
                  />
                  <div className='d-flex ac-jc'>
                    <img
                      src={image?.name ? URL.createObjectURL(image) : no_image}
                      style={{
                        width: '100px',
                        height: '100px',
                        margin: '10px 0px',
                      }}
                      alt="Cropped"
                    />
                  </div>
                </div>
              </div>
            )}
            {tabs == 4 && (
              <div>
                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  Country
                </h4>
                <Select
                  className='input-pop_box'
                  options={countryList}
                  value={country}
                  onChange={(e) => { setCountry(e); locationLists(2, e.value) }}
                />
                {/* <input type="text" className="input-pop ps-2 w-100" placeholder="Country" /> */}
                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  State
                </h4>
                <Select
                  className='input-pop_box'
                  options={stateList}
                  value={state}
                  onChange={(e) => { setState(e); locationLists(3, e.value) }}
                />
                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  City
                </h4>
                <Select
                  className='input-pop_box'
                  options={cityList}
                  value={city}
                  onChange={(e) => setCity(e)}
                />
                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                  Enter Area Name
                </h4>
                <input type="text" value={inputFeild} onChange={(e) => setInputFeild(e.target.value)} className="input-pop ps-2 w-100" placeholder="Area" />
              </div>
            )}
            <div className='d-flex ac-jb mt-3'>
              <button onClick={() => setPopup(false)} className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mt-3">
                Cancel
              </button>
              <button
                // onClick={() => { tabs == 1 ? countryAdd() : tabs == 2 ? countryAdd() : tabs == 3 ? countryAdd() : tabs == 4 ? countryAdd() : "" }}
                onClick={() => { countryAdd() }}
                className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mt-3">
                Submit
              </button>
            </div>
          </div>
        </div>
      )
      }
      {loader && (<div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
        <Spinner animation="border" className="primary1" />
      </div>
      )}
    </div >
  )
}
export default Locations